import _ from 'lodash'
import menuMixins from './menuMixins'

export default {
  name: 'KMenu',
  mixins: [menuMixins],
  provide() {
    return {
      menu: this,
    }
  },
  props: {
    defaultActiveIndex: {},
    theme: {
      type: String,
      validator: value => ['white', 'dark'].indexOf(value) !== -1,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    mode: {
      validator: value => ['inline', 'popper'].indexOf(value) > -1,
      default: 'inline',
    },
    popperClass: { // 如果 mode 为 popper 时，作用在 popper 上的类
      validator: (value) => _.isString(value) || _.isArray(value) || _.isObjectLike(value),
      // '{}'
      default() {
        return {}
      },
    },
    // 是否开启手风琴模式
    accordion: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeIndex: null,
    }
  },
  computed: {
    innerMode() {
      if (this.collapsed) {
        return 'popper'
      }
      return this.mode
    },
  },
  watch: {
    activeIndex(value) {
      this.$emit('item-active', value)
    },
  },
  created() {
    this.activeIndex = this.defaultActiveIndex
  },
  methods: {
    // api
    setActiveIndex(index) {
      this.activeIndex = index
    },
  },
  render() {
    const style = {}

    if (this.collapsed) {
      style.width = '65.5px' // 24px + 24px + 1.25 * 14
    }

    const css = {
      'km-menu': true,
      'km-menu--white': this.theme === 'white',
      'km-menu--popper': this.mode === 'popper',
      'km-menu--collapsed': this.collapsed,
    }

    const attrs = {
      disabled: this.disabled,
    }

    const props = {
      color: this.type,
      value: this.inputValue,
      lazy: true,
      size: this.size,
    }

    const events = {}

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      props: props,
      on: events,
    }

    return (
      <div
        {...data}>
        {this.$slots.default}
      </div>
    )
  },
}
